module.exports = __webpack_public_path__ + "static/media/amazon-icon.d968aaa2.png";